export default {
  common: {
    save: "Save changes",
    cancel: "Cancel",
    saving: "Saving...",
    updating: "Updating...",
    back: "Back",
    comingSoon: "More features coming soon",
    error: "Error",
    success: "Success",
    toast: {
      success: "Success",
      error: "Error",
      info: "Information",
      warning: "Warning",
      copied: "Copied to clipboard",
      saved: "Changes saved",
      deleted: "Successfully deleted",
      updated: "Successfully updated"
    },
    in: "in"
  },
  auth: {
    signOut: "Sign Out",
    signOutSuccess: "Signed out successfully",
    redirectingHome: "Redirecting to home page...",
    loginWithEmail: "Login with Email",
    createAccount: "Create Account",
    welcomeBack: "Welcome Back",
    enterEmailForCode: "Enter your email to receive a one-time code",
    signUpToManageTrips: "Sign up to start managing your trips",
    signInToAccessTrips: "Sign in to access your trips",
    password: "Password",
    otpLogin: "Email Login",
    register: "Register",
    emailConfirmationRequired: "Email Confirmation Required",
    checkEmailForConfirmation: "Please check your email inbox for a confirmation link. You need to confirm your email address before continuing.",
    invalidEmail: "Please enter a valid email address",
    confirmEmail: "Confirm email address",
    emailMismatch: "Email addresses do not match",
    verificationEmailSent: "Please check your emails to find a verification code.",
    incorrectVerificationCode: "Verification code is incorrect",
    loginSuccess: "Successfully logged in!",
    registrationPasswordSuccess: "Successfully registered and password saved!",
    incorrectCredentials: "Credentials are incorrect",
    otpRequestFailed: "Failed to request Code",
    unexpectedError: "An unexpected error occurred",
    codeSent: "Code Sent",
    checkEmailForCode: "Please check your email for the verification code.",
    sessionCreationFailed: "Failed to create session",
    passwordValidation: "Password should contain at least one uppercase letter, one lowercase letter, one number, one special character and should be between 8 to 15 characters long.",
    enterVerificationCode: "Enter the verification code sent to",
    enter6DigitCode: "Enter 6-digit code",
    optionalPassword: "You can optionally set a password for your account",
    passwordOptional: "Password (Optional)",
    confirmPassword: "Confirm password",
    registrationComplete: "Registration Complete!",
    accountCreatedRedirect: "Your account has been created successfully. You will be redirected shortly...",
    validateEmail: "Validate your email",
    signIn: "Sign In",
    sending: "Sending...",
    verifyEmail: "Verify Email",
    backToEmail: "Back to email",
    verifying: "Verifying...",
    validateOTP: "Validate OTP",
    noAccount: "Don't have an account? Sign up",
    travelAppLogo: "Travel App",
    forgotPassword: "Forgot Password",
    forgotPasswordInstructions: "Please login using your email and then change your password",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    confirmEmailAddress: "Confirm Email Address",
    termsAgreementPart1: "By creating your account, you agree to our",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    adtdTripPWaiting: "Your trip is ready to be imported",
    adtdTripPWaitingDescription: "Please login to your account, or create one to proceed. We will ensure the booking is matching your identity.",
    loginDescription: "Track flights, organise your trips, and access all your travel information. Everything you need for a seamless journey, all in one place.",
    loginAppDescription: "All your travel info, in one place"
  },
  settings: {
    title: "Settings",
    profile: {
      title: "My Profile",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      country: "Country",
      city: "City",
      selectCountry: "Select or type a country",
      enterCity: "Enter your city"
    },
    language: {
      title: "Language",
      preferred: "Preferred Language",
    },
    currency: {
      title: "Currency",
      preferred: "Preferred Currency"
    },
    notifications: {
      title: "Notifications",
      emailNotifications: "Email Notifications",
      description: "Receive email notifications about important updates",
    },
    consent: {
      title: "Consent Management",
      open: "Open Consent Manager",
      description: "Manage your privacy and cookie preferences"
    },
    about: {
      title: "About Us",
      tos: "Terms of Service",
      privacy: "Privacy Policy",
      faq: "FAQ",
    },
    contact: {
      title: "Contact Us",
      email: "feedback@checkmytrip.com",
    },
    social: {
      title: "Find Us on Social Media",
    },
    profileUpdated: "Profile updated successfully",
    updateError: "Error updating profile",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters long",
    passwordUpdated: "Password updated successfully",
    changePassword: "Change Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    updatePassword: "Update Password",
    deleteAccount: "Delete Account",
    deleteAccountDescription: "Permanently delete your account and all associated data",
    confirmDelete: "Are you sure?",
    deleteWarning: "This action cannot be undone. This will permanently delete your account and remove all your data from our servers.",
    confirmDeleteButton: "Yes, delete my account",
    accountDeleted: "Your account has been deleted successfully.",
    deleteError: "Failed to delete account",
    feedback: {
      title: "Feedback",
      description: "We value your feedback. Help us improve our service by sharing your thoughts.",
      button: "Give Feedback"
    }
  },
  index: {
    greeting: "Hi, Traveler",
    greetingWithName: "Hi, {{name}}",
    manageTrips: "Manage your trips",
    bookingRef: "Booking Reference",
    lastName: "Last Name",
    addTrip: "Add Trip",
    timeline: "Your Timeline",
    travelPlans: "Your Travel Plans",
    errorFetchingTrips: "Make sure you are connected to an account with corresponding name and email.",
    viewUpcomingFlights: "View upcoming flights",
    importAdtdTripSuccess: "Trip imported successfully",
    importAdtdTripError: "Unable to import trip to this account",
    checkYourTrips: "Check your trips in the app",
    welcome: {
      title: "Welcome to Your Travel Journey!",
      features: {
        tripManagement: {
          title: "Trip Management",
          description: "Keep all your travel details in one place - flights, hotels, and activities."
        },
        tripAlerts: {
          title: "Trip Alerts",
          description: "Receive timely notifications about your flights, gate changes, and important travel updates."
        },
        offers: {
          title: "Personalized Offers",
          description: "Receive tailored travel deals based on your preferences and past trips."
        },
        inspiration: {
          title: "Travel Inspiration",
          description: "Discover new destinations and receive personalized recommendations for your adventures."
        }
      },
      tips: {
        profile: "Complete your profile to get personalized recommendations",
        addTrip: "Click the + button to add your first trip",
        notifications: "Enable notifications to never miss important travel updates",
        dates: "Keep track of important travel dates in your calendar"
      },
      getStarted: "Quick Tips to Get Started",
      ready: "Ready to start your journey? Let's make every trip memorable! ✈️"
    }
  },
  tripCard: {
    daysLeft: "days",
    flightDetails: "Flight details",
    terminal: "Terminal",
    gate: "Gate",
    checkIn: "Check-in",
    checkStatus: "Check status",
    flightInfo: "Flight information",
    airline: "Airline",
    flight: "Flight",
    departure: "Departure",
    arrival: "Arrival",
    getFlightDetails: "Get flight details",
    destinationInfo: "Destination info",
    weather: "Weather",
    activities: "Recommended activities",
    food: "Restaurants & cafés",
    cabinClass: "Cabin Class",
    bookingReference: "Booking Reference",
    confirmationNumbers: "Confirmation Numbers",
    // Time related labels
    today: "Today",
    dayAgo: "1 day ago",
    daysAgo: "{{count}} days ago",
    remainingDay: "1 remaining day",
    remainingDays: "{{count}} remaining days",
    tripStatus: {
      ongoing: "Ongoing trip",
      upcoming: "Upcoming trip",
      past: "Past trip"
    },
    hotel: "Hotel",
    car: "Car",
    activity: "Activity",
    viewOnMap: "View on map",
    direct: "Direct",
    addToCalendar: "Add to calendar",
    tripInfo: "Trip Info",
    destination: "Destination",
    noFlightInfoFound: "No flight information found",
    noFlightStatusAvailable: "No flight status information available",
    flightStatus: "Flight Status",
    flightInfoUpdated: "Flight information updated",
    failedFlightStatus: "Failed to check flight status. Please try again.",
    tripDetails: "Trip Details",
    deleteTrip: "Delete Trip",
    confirmDelete: "Delete Trip?",
    deleteWarning: "This action cannot be undone. This will permanently delete your trip to {{tripName}} and remove it from your account.",
    confirmDeleteButton: "Yes, delete trip",
    tripDeleted: "Trip has been deleted successfully.",
    deleteError: "Failed to delete trip",
    carRental: "Car Rental",
    carModel: "Car Model",
    pickupLocation: "Pickup Location",
    dropoffLocation: "Dropoff Location",
    pickup: "Pickup",
    dropoff: "Dropoff",
    confirmationNumber: "Confirmation Number",
    notifications: "Notifications",
    notificationsDescription: "Important notifications about your trips",
    noNotifications: "No notifications yet",
    notificationsOnMobile: "This feature is only available on mobile app at the moment",
    taxiTransfer: "Taxi Transfer",
    taxiTransferDesc: "Book a taxi transfer to your hotel or airport",
    taxiTransferComingSoon: "Taxi transfer coming soon",
    economy: "Economy",
    loadingNotifications: "Loading notifications..."
  },
  weather: {
    in: "Weather in",
    loading: "Loading weather data...",
    currentWeather: "Current Weather",
    forecast: "Forecast",
    temperature: "Temperature",
    feelsLike: "Feels like",
    wind: "Wind",
    humidity: "Humidity",
    precipitation: "Precipitation",
    pressure: "Pressure",
    visibility: "Visibility",
    uvIndex: "UV Index",
    sunrise: "Sunrise",
    sunset: "Sunset",
    daily: "Daily",
    hourly: "Hourly",
    today: "Today",
    tomorrow: "Tomorrow",
    min: "Min",
    max: "Max"
  },
  assistant: {
    title: "AI Assistant",
    comingSoon: "Coming soon..."
  },
  discover: {
    title: "Discover Experiences",
    subtitle: "Find and explore activities for your next adventure",
    getInspired: "Get Inspired",
    searchFilters: "Search Filters",
    search: "Search",
    city: "City",
    enterCityName: "Enter city name",
    priceRange: "Price Range",
    min: "Min",
    max: "Max",
    radius: "Radius (km)",
    enterRadius: "Enter radius",
    searchButton: "Search",
    categoryTypes: "Categories",
    popularActivities: "Popular Activities",
    searchPlaceholder: "Search activities, places, or experiences...",
    allActivities: "All Activities",
    inspiration: {
      location: "Location",
      price: "Price Range",
      bestTimeToVisit: "Best Time to Visit",
      howToGetThere: "How to Get There"
    },
    categories: {
      tour: "Tour",
      adventure: "Adventure",
      food: "Food & Drink",
      culture: "Culture",
      sightseeing: "Sightseeing",
      entertainment: "Entertainment",
      nature: "Nature",
      wellness: "Wellness",
      sport: "Sport",
      workshop: "Workshop"
    }
  },
  newTrip: {
    title: "Add a New Trip",
    bookingReference: "Booking Reference",
    bookingReferenceDesc: "Enter your 6 characters booking reference and make sure the first and last name of your profile are the same as in your reservation.",
    bookingRefPlaceholder: "Reference (e.g. ABC123)",
    bookingRefTooShort: "Booking reference must be at least 6 characters long",
    bookingRefTooLong: "Booking reference can be maximum 10 characters long",
    lastNamePlaceholder: "Last Name",
    findBooking: "Find Booking",
    emailForward: "Forward Your Booking Email",
    emailForwardDesc: "Forward your booking confirmation email to add your trip",
    copyEmail: "Copy Email Address",
    emailCopiedDesc: "Email address copied to clipboard",
    connectGmail: "Connect Gmail",
    gmailSync: "Sync with Gmail",
    gmailSyncDesc: "Automatically import trips from your Gmail",
    gmailConsent: "Gmail Consent",
    gmailProcessing: "Processing your Gmail consent",
    manual: "Manual Entry",
    manualEntryDesc: "Manually enter your trip details",
    startManual: "Start Manual Entry",
    bookingSubmitted: "Booking Submitted",
    processingBooking: "Error processing booking:",
    profileMismatch: "Sorry, your profile information doesn't match the booking. Please head to Profile and make sure your first and last names are the same as the ones used to make the reservation. You can also try to import your trip with the following options below by forwarding your booking confirmation email or enter the trip manually.",
    drawer: {
      addTripDetails: "Add Trip Details",
      tripInfo: "Trip Information",
      tripName: "Trip Name",
      tripType: "Trip Type",
      selectTripType: "Select Trip Type",
      leisure: "Leisure",
      business: "Business",
      family: "Family",
      bleisure: "Bleisure",
      travelers: "Travelers",
      addFlight: "Add Flight",
      adding: "Adding...",
      flightNumber: "Flight Number",
      departureDate: "Departure Date",
      addedFlights: "Added Flights",
      from: "From",
      to: "To",
      terminal: "Terminal",
      departure: "Departure",
      arrival: "Arrival",
      addHotel: "Add Hotel",
      hotelName: "Hotel Name",
      cityName: "City Name",
      selectCheckInOut: "Select Check-in & Check-out Dates",
      addedHotels: "Added Hotels",
      createTrip: "Create Trip",
      selectFlight: "Select Flight",
      confirmFlight: "Confirm Flight",
      step1: "Info",
      step2: "Flights",
      step3: "Hotels",
      step4: "Review",
      next: "Next",
      back: "Back",
      review: "Review",
      flightsStepEmpty: "Add at least one flight to your trip",
      flightsStepWithFlights: "You've added {{count}} flight(s)",
      hotelsStepEmpty: "Add hotels to your trip (optional)",
      hotelsStepWithHotels: "You've added {{count}} hotel(s)",
      reviewTrip: "Review Your Trip",
      reviewDescription: "Check your trip details before creating it",
      tripSummary: "Trip Summary",
      flightsSummary: "Flights",
      hotelsSummary: "Hotels"
    }
  },
  sidebar: {
    myTrips: "My Trips",
    discover: "Discover",
    newTrip: "New Trip",
    profile: "Profile",
    feedback: "Feedback"
  },
  errors: {
    configurationError: "Configuration Error",
    websiteNotConfigured: "The website is not properly configured."
  }
}
